import { useMutation } from "react-query"
import usePopup from "../../../hooks/usePopup"
import { saveorUpdateRadiology } from "../Services"

const useSaveRadioResult = (successFunction?:()=>void)=>{
    const {showSnackbar} = usePopup()
    return useMutation(saveorUpdateRadiology,{
        onSuccess:(result)=>{
            if(result.responseIndicator == "success"){
              showSnackbar({
                message:result.response,
                open:true,
                variant:"success",
                duration:3000
              })
              if(successFunction){
                successFunction()
              }
            }else{
              showSnackbar({
                message:result?.responseMessage || "Something went wrong !",
                open:true,
                variant:"warning",
                duration:3000
              })
            } 
        },
        onError:(e:any)=>{
          showSnackbar({
            message:e?.response?.data?.responseMessage || "Something went wrong !",
            open:true,
            variant:"error",
            duration:3000
          })
        }
      })
}

export default useSaveRadioResult